import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { formatDate } from '@root/src/utils/dates';
import { useRollbarContext } from '@services/rollbar';
import ssrProvider from '@services/ssrProvider';
import { GET_DATA_FOR, getServerSideData, useGetClientSideData } from '@services/dataHandler/getPageData';
import ReduxWrapper from '@services/store';
import { isModalClosed } from '@services/dataHandler/utils';
import EventSubscriptionTemplate from '@features/eventDetail/templates/EventSubscriptionTemplate';
import { selectEventDetail } from '@features/eventDetail/slices/eventDetailServerSlice';
import { MODAL_NAME } from '@features/ui-layout/templates/ModalContainer';
import { getQueryEventId } from '@features/eventDetail/utils';

const SubscriptionPage = () => {
  useRollbarContext('Event : SubscriptionPage');
  const modalClosed = isModalClosed([MODAL_NAME.subscriptionCartCreate, MODAL_NAME.menu]);
  const isLoading = useGetClientSideData(GET_DATA_FOR.EVENT_SUBSCRIPTION, [modalClosed]);

  const router = useRouter();
  const event = useSelector(selectEventDetail(getQueryEventId(router.query)));
  const { t } = useTranslation();

  const eventSubscriptionStartDate = event?.status?.registrationFrom ? formatDate(event?.status?.registrationFrom) : '-';
  const eventSubscriptionEndDate = event?.status?.registrationTo ? formatDate(event?.status?.registrationTo) : '-';

  return (
    <>
      <Head>
        <title>{`${t('head_EventSubscriptionTitle.message', { event: event?.name })} ${t('head_siteTitle.message')}`}</title>
        <meta
          name="description"
          content={
            t('head_EventSubscriptionDescription.message',
              {
                eventName: event?.name,
                eventSubscriptionStartDate,
                eventSubscriptionEndDate,
              })
          }
        />
      </Head>
      <EventSubscriptionTemplate isLoading={isLoading} />
    </>
  );
};

export default SubscriptionPage;

export const getServerSideProps = ReduxWrapper.getServerSideProps(
  (store) => async (serverSideContext) => ssrProvider({
    store,
    serverSideContext,
    process: async ({ store }) => {
      await getServerSideData(
        store,
        serverSideContext,
        GET_DATA_FOR.EVENT_SUBSCRIPTION
      );
    },
  })
);
